import React from 'react';
import styled from 'styled-components';
import {TypographyChildrenProps} from './Typography';
import {getLocale} from '@epic-core/common';
import {CombinedTextColorProps, useCombinedTextColor} from 'epic-ue-theme';

const Heading = styled.h5<CombinedTextColorProps>`
    font-family: ${(p) => p.theme.fonts.brutal.regular};
    &.loc-en-US {
        font-family: ${(p) => p.theme.fonts.fira.regular};
    }
    &.loc-ko {
        word-wrap: break-word;
        word-break: keep-all;
    }
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin: 0;
    color: ${(p) => useCombinedTextColor(p.color)};
`;

export const TypographyHeading5 = ({
    children,
    color,
    as,
    className = ''
}: TypographyChildrenProps): JSX.Element => {
    return (
        <Heading className={`heading h5 loc-${getLocale()} ${className}`} color={color} as={as}>
            {children}
        </Heading>
    );
};
